export const breakpoint = '960px';

export const pageWidth = '1280px';

export const headerHeight = '80px';
